module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f47b.d92e0fd8.svg";